export var buildReducer = function (cases) { return function (state, action) {
    return cases[action.type] ? cases[action.type](state, action) : state;
}; };
